import React, { Fragment, useEffect, forwardRef, useContext } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton/IconButton";
import AddIcon from "@mui/icons-material/Add";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ChipList from "../common/ChipList";
import ProjectContext from "../../context/project/ProjectContext";
import Loader from "../common/Loader";
import { Assignments } from "../../types/project";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

function AddIntelliFiberUserRoles(props: {
  showDialog: boolean;
  handleClose: Function;
}) {
  const [open, setOpen] = React.useState(props.showDialog);

  let {
    intelliFiberUserRoles,
    intelliFiberRoles,
    users,
    loading,
    addIntelliFiberUserRole,
  } = useContext(ProjectContext);

  const handleClose = () => {
    console.log("close");
    props.handleClose();
    setOpen(false);
  };

  const [selectedRole, setSelectedRole] = React.useState("");
  const [selectedUsers, setSelectedUsers] = React.useState<string[]>([]);
  const [localAssignments, setLocalAssignments] = React.useState<Assignments[]>(
    []
  );
  const [assignmentLookup, setAssignmentLookup] = React.useState<Assignments[]>(
    []
  );

  const [availableUsers, setAvailableUsers] = React.useState(
    intelliFiberUserRoles
  );
  const userRef = React.useRef<HTMLInputElement>(null);

  const handleUserDelete = (userToDelete: string) => {
    setSelectedUsers((users) => users.filter((user) => user !== userToDelete));
  };

  const addUserToRole = (event: React.MouseEvent<HTMLElement>) => {
    if (userRef.current) {
      console.log("MOUSE EVENT", userRef.current.value);
      //   setSearchTerm(userRef.current.value);
      if (
        userRef.current.value &&
        !selectedUsers.includes(userRef.current.value)
      ) {
        setSelectedUsers((users) => {
          console.log(`Users: ${users}`);
          let newUsers = [...users];
          if (userRef.current) newUsers.push(userRef.current.value);
          console.log("Updated Users:", users);
          return newUsers;
        });

        const assignment = {
          UserID: users?.find(
            (user) => user.UserID === userRef.current?.value
          )?.UserID,
          RoleID: selectedRole,
        };
        setLocalAssignments([...localAssignments, assignment]);
        console.log("@HEY", localAssignments);
      }
      userRef.current.value = "";
    }
  };

  const handleRoleChange = (event: SelectChangeEvent<typeof selectedRole>) => {
    const {
      target: { value },
    } = event;
    console.log("@Handle Role", value);
    setSelectedRole(value);
    const _existingUsers = assignmentLookup?.filter(
      (item) => item.RoleID === value
    );
    // console.log("USers", JSON.stringify(users));
    console.log(`Existing Users: ${JSON.stringify(_existingUsers)}`);

    const _availUsers =
      (users &&
        users.filter(
          (user) =>
            !_existingUsers.some(
              (existingUser) => existingUser.UserID === user.UserID
            )
        )) ||
      [];

    setAvailableUsers([..._availUsers]);
    console.log(`Available Usets: ${JSON.stringify(_availUsers)}`);
  };

  const addIntelliFiberUserRoles = async (formData) => {
    console.log("@@Add IntelliFiberUserRoles:", formData);
    if (addIntelliFiberUserRole) {
      try {
        // const formData = {
        //   UserID: "rachel.cepeda",
        //   RoleID: "1001",
        // };
        const res = await addIntelliFiberUserRole(formData);
        console.log("@@IntelliFiberUserRoles add:", res);
      } catch (error) {
        console.log("@@IntelliFiberUserRoles add Error:", error);
      }
    }
  };

  const updateRoles = async (event: React.MouseEvent<HTMLElement>) => {
    //close dialog
    // @ts-ignore

    console.log("@Assignments", localAssignments);
    addIntelliFiberUserRoles(localAssignments);
    // if (assignRoleToUserV2) {
    //   let res = await assignRoleToUserV2(localAssignments);
    //   console.log("UPDATE RES<", res);
    //   if (res === true) handleClose();
    // }
    handleClose();
  };

  useEffect(() => {
    console.log("Updated Users##:", selectedUsers);
  }, [selectedUsers]);

  useEffect(() => {
    console.log("Existing assignments##:", intelliFiberUserRoles);
    if (intelliFiberUserRoles) setAssignmentLookup(intelliFiberUserRoles);
  }, [intelliFiberUserRoles]);

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Grid container minWidth={500}>
          <Grid
            md={12}
            sx={{
              margin: 2,
              px: 2,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <FormControl required fullWidth>
              <InputLabel id='role-select-label'>Role</InputLabel>
              <Select
                labelId='role-select-label'
                id='role-select'
                value={selectedRole}
                label='Role'
                onChange={handleRoleChange}
                autoFocus
              >
                {intelliFiberRoles &&
                  intelliFiberRoles
                    .filter((item) => item.IsProjectRole === "N")
                    .map((role: any) => (
                      <MenuItem key={role.OBJECTID} value={role.RoleID}>
                        {role.RoleName}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            md={12}
            sx={{
              margin: 2,
              px: 2,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Grid
              md={4}
              sx={{
                px: 2,
                display: "flex",
                flexDirection: "row",
              }}
            >
              User Id:
            </Grid>
            <Grid
              md={8}
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Autocomplete
                disabled={!selectedRole}
                id='search-auto-complete'
                fullWidth
                // freeSolo
                //@ts-ignore
                options={
                  !availableUsers
                    ? ""
                    : availableUsers.map((option: any) => option.UserID)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Search'
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                    inputRef={userRef}
                  />
                )}
              />
              <Button
                variant='contained'
                color='secondary'
                sx={{ mb: 9 }}
                onClick={addUserToRole}
              >
                <IconButton
                  aria-label='search'
                  component='label'
                  sx={{ backgroundColor: "secondary" }}
                >
                  <AddIcon />
                </IconButton>
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className='center-pane' sx={{ mx: 2, px: 2 }}>
          <ChipList list={selectedUsers} deleteHandler={handleUserDelete} />
        </Grid>
        <Grid
          container
          sx={{ margin: 2, px: 2 }}
          display='flex'
          flexDirection='row'
          justifyContent='flex-end'
          minHeight={100}
        >
          <Box
            display='flex'
            flexDirection='row'
            justifyContent='flex-end'
            minHeight={100}
            sx={{ margin: 1, padding: 3 }}
          >
            <Button
              variant='contained'
              color='secondary'
              sx={{ margin: 1, padding: 1 }}
              onClick={handleClose}
            >
              Back
            </Button>
            <Button
              disabled={selectedUsers.length === 0 || !selectedRole}
              variant='contained'
              color='primary'
              onClick={updateRoles}
              // disabled={!formIsValid}
              sx={{ margin: 1, padding: 1 }}
            >
              Update
            </Button>
          </Box>
        </Grid>

        {loading ? (
          <Grid container justifyContent='center' alignItems='center'>
            <Loader />
          </Grid>
        ) : null}
      </Dialog>
    </Fragment>
  );
}

export default AddIntelliFiberUserRoles;
